import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Row, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useImmer } from 'use-immer'
import ShimmeringEffect from '../../components/shimmering/ShimmeringEffect'
import { encodeId, formatMRP } from '../../lib/AllGlobalFunction'
import { isSellerPanel } from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'
import { _productImg_ } from '../../lib/ImagePath'

const TopSellingProducts = ({ values, setFieldValue }) => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { userInfo } = useSelector((state) => state?.user)
  const [data, setData] = useImmer({
    topSellingProducts: []
  })

  const fetchData = async (days = 'All') => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'Dashboard/getTopSellingProducts',
        queryString: `?days=${days}&sellerId=${
          isSellerPanel ? userInfo?.userId : ''
        }`
      })

      setLoading(false)

      if (response?.status === 200) {
        setData((draft) => {
          draft.topSellingProducts = response?.data?.data
        })
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return loading ? (
    <ShimmeringEffect />
  ) : (
    <div
      style={{
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
      }}
      className='pv-dashbord-chart-col'
    >
      <Row className='w-100 m-auto py-3'>
        <Col md={12}>
          <div className='d-flex justify-content-between align-items-center'>
            <caption className='cfz-24'>Top Selling Products</caption>

            <Dropdown>
              <Dropdown.Toggle className='btn-light' id='dropdown-basic'>
                {values?.topSellingProducts
                  ? values?.topSellingProducts
                  : 'All'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('All')
                    setFieldValue('topSellingProducts', 'All')
                  }}
                >
                  All
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('Today')
                    setFieldValue('topSellingProducts', 'Today')
                  }}
                >
                  Today
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('7')
                    setFieldValue('topSellingProducts', 'Last Week')
                  }}
                >
                  Last Week
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('15')
                    setFieldValue('topSellingProducts', 'Last 15 Days')
                  }}
                >
                  Last 15 Days
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('30')
                    setFieldValue('topSellingProducts', 'This Month')
                  }}
                >
                  This Month
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('90')
                    setFieldValue('topSellingProducts', 'Last 3 Month')
                  }}
                >
                  Last 3 Month
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
        <Col md={12}>
          <Table className='align-middle table-list mt-3'>
            <thead>
              <tr>
                <th>Product Details</th>
                <th>Total Orders</th>
                <th>Total Selling</th>
              </tr>
            </thead>
            <tbody>
              {data?.topSellingProducts?.length > 0 ? (
                data?.topSellingProducts?.map((data) => (
                  <tr key={Math.floor(Math.random() * 100000)}>
                    <td
                      role='button'
                      onClick={() => {
                        navigate(
                          `/manage-product?id=${encodeId(data?.productID)}`
                        )
                      }}
                    >
                      <div className='d-flex gap-4 align-items-center'>
                        <img
                          className='rounded-2 cw-80'
                          src={
                            data?.productImage
                              ? `${process.env.REACT_APP_IMG_URL}${_productImg_}${data?.productImage}`
                              : 'https://placehold.jp/50x50.png'
                          }
                          alt='...'
                        />
                        <div>
                          <p className='mb-0'> {data?.productName}</p>
                          <p className='mb-0 cfz-14'>
                            SKU :{' '}
                            <span className='fw-600'> {data?.productSKU}</span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>{data?.totalOrders}</td>
                    <td>{formatMRP(data?.totalSell)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className='text-center'>
                    No products available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  )
}

export default TopSellingProducts
